import {
  type EnvironmentValue,
  TeamValue,
  WorkloadValue,
} from '@ace-clublabs/aws-tags';
import { LogCannon } from '@ace-clublabs/log-cannon';

import { LOG_CANNON_PROD_API_KEY } from '@/providers/logCannonConfig';

type ILogCannonOptions = {
  team: TeamValue;
  workload: WorkloadValue;
  component: string;
  runtime: string;
  runtimeVersion: string;
  endpoint?: string;
  environment?: EnvironmentValue;
};

export const initLogCannon = () => {
  const logCannonOptionsTRVL: ILogCannonOptions = {
    team: TeamValue.Travel,
    workload: WorkloadValue.TravelScheduler,
    component: 'apiWrapper',
    runtime: 'browser',
    runtimeVersion: 'browser',
  };

  // biome-ignore lint/suspicious/noExplicitAny: dependency version conflict between @ace-clublabs/aws-tags packages
  LogCannon.init(LOG_CANNON_PROD_API_KEY, logCannonOptionsTRVL as any);
};
